function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*!
* sweetalert2 v11.7.12
* Released under the MIT License.
*/
!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).Sweetalert2 = t();
}(this, function () {
  "use strict";

  var e = {},
    t = function t(_t2) {
      return new Promise(function (o) {
        if (!_t2) return o();
        var n = window.scrollX,
          i = window.scrollY;
        e.restoreFocusTimeout = setTimeout(function () {
          e.previousActiveElement instanceof HTMLElement ? (e.previousActiveElement.focus(), e.previousActiveElement = null) : document.body && document.body.focus(), o();
        }, 100), window.scrollTo(n, i);
      });
    };
  var o = {
    promise: new WeakMap(),
    innerParams: new WeakMap(),
    domCache: new WeakMap()
  };
  var n = "swal2-",
    i = ["container", "shown", "height-auto", "iosfix", "popup", "modal", "no-backdrop", "no-transition", "toast", "toast-shown", "show", "hide", "close", "title", "html-container", "actions", "confirm", "deny", "cancel", "default-outline", "footer", "icon", "icon-content", "image", "input", "file", "range", "select", "radio", "checkbox", "label", "textarea", "inputerror", "input-label", "validation-message", "progress-steps", "active-progress-step", "progress-step", "progress-step-line", "loader", "loading", "styled", "top", "top-start", "top-end", "top-left", "top-right", "center", "center-start", "center-end", "center-left", "center-right", "bottom", "bottom-start", "bottom-end", "bottom-left", "bottom-right", "grow-row", "grow-column", "grow-fullscreen", "rtl", "timer-progress-bar", "timer-progress-bar-container", "scrollbar-measure", "icon-success", "icon-warning", "icon-info", "icon-question", "icon-error"].reduce(function (e, t) {
      return e[t] = n + t, e;
    }, {}),
    s = ["success", "warning", "info", "question", "error"].reduce(function (e, t) {
      return e[t] = n + t, e;
    }, {}),
    r = "SweetAlert2:",
    a = function a(e) {
      return e.charAt(0).toUpperCase() + e.slice(1);
    },
    l = function l(e) {
      console.warn("".concat(r, " ").concat("object" == _typeof(e) ? e.join(" ") : e));
    },
    c = function c(e) {
      console.error("".concat(r, " ").concat(e));
    },
    u = [],
    d = function d(e, t) {
      var o;
      o = "\"".concat(e, "\" is deprecated and will be removed in the next major release. Please use \"").concat(t, "\" instead."), u.includes(o) || (u.push(o), l(o));
    },
    p = function p(e) {
      return "function" == typeof e ? e() : e;
    },
    m = function m(e) {
      return e && "function" == typeof e.toPromise;
    },
    g = function g(e) {
      return m(e) ? e.toPromise() : Promise.resolve(e);
    },
    h = function h(e) {
      return e && Promise.resolve(e) === e;
    },
    f = function f() {
      return document.body.querySelector(".".concat(i.container));
    },
    b = function b(e) {
      var t = f();
      return t ? t.querySelector(e) : null;
    },
    y = function y(e) {
      return b(".".concat(e));
    },
    w = function w() {
      return y(i.popup);
    },
    v = function v() {
      return y(i.icon);
    },
    C = function C() {
      return y(i.title);
    },
    A = function A() {
      return y(i["html-container"]);
    },
    k = function k() {
      return y(i.image);
    },
    B = function B() {
      return y(i["progress-steps"]);
    },
    P = function P() {
      return y(i["validation-message"]);
    },
    E = function E() {
      return b(".".concat(i.actions, " .").concat(i.confirm));
    },
    $ = function $() {
      return b(".".concat(i.actions, " .").concat(i.cancel));
    },
    x = function x() {
      return b(".".concat(i.actions, " .").concat(i.deny));
    },
    T = function T() {
      return b(".".concat(i.loader));
    },
    L = function L() {
      return y(i.actions);
    },
    S = function S() {
      return y(i.footer);
    },
    O = function O() {
      return y(i["timer-progress-bar"]);
    },
    M = function M() {
      return y(i.close);
    },
    j = function j() {
      var e = w().querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'),
        t = Array.from(e).sort(function (e, t) {
          var o = parseInt(e.getAttribute("tabindex")),
            n = parseInt(t.getAttribute("tabindex"));
          return o > n ? 1 : o < n ? -1 : 0;
        }),
        o = w().querySelectorAll('\n  a[href],\n  area[href],\n  input:not([disabled]),\n  select:not([disabled]),\n  textarea:not([disabled]),\n  button:not([disabled]),\n  iframe,\n  object,\n  embed,\n  [tabindex="0"],\n  [contenteditable],\n  audio[controls],\n  video[controls],\n  summary\n'),
        n = Array.from(o).filter(function (e) {
          return "-1" !== e.getAttribute("tabindex");
        });
      return _toConsumableArray(new Set(t.concat(n))).filter(function (e) {
        return X(e);
      });
    },
    I = function I() {
      return q(document.body, i.shown) && !q(document.body, i["toast-shown"]) && !q(document.body, i["no-backdrop"]);
    },
    H = function H() {
      return w() && q(w(), i.toast);
    },
    D = function D(e, t) {
      if (e.textContent = "", t) {
        var _o = new DOMParser().parseFromString(t, "text/html");
        Array.from(_o.querySelector("head").childNodes).forEach(function (t) {
          e.appendChild(t);
        }), Array.from(_o.querySelector("body").childNodes).forEach(function (t) {
          t instanceof HTMLVideoElement || t instanceof HTMLAudioElement ? e.appendChild(t.cloneNode(!0)) : e.appendChild(t);
        });
      }
    },
    q = function q(e, t) {
      if (!t) return !1;
      var o = t.split(/\s+/);
      for (var _t3 = 0; _t3 < o.length; _t3++) {
        if (!e.classList.contains(o[_t3])) return !1;
      }
      return !0;
    },
    V = function V(e, t, o) {
      if (function (e, t) {
        Array.from(e.classList).forEach(function (o) {
          Object.values(i).includes(o) || Object.values(s).includes(o) || Object.values(t.showClass).includes(o) || e.classList.remove(o);
        });
      }(e, t), t.customClass && t.customClass[o]) {
        if ("string" != typeof t.customClass[o] && !t.customClass[o].forEach) return void l("Invalid type of customClass.".concat(o, "! Expected string or iterable object, got \"").concat(_typeof(t.customClass[o]), "\""));
        R(e, t.customClass[o]);
      }
    },
    N = function N(e, t) {
      if (!t) return null;
      switch (t) {
        case "select":
        case "textarea":
        case "file":
          return e.querySelector(".".concat(i.popup, " > .").concat(i[t]));
        case "checkbox":
          return e.querySelector(".".concat(i.popup, " > .").concat(i.checkbox, " input"));
        case "radio":
          return e.querySelector(".".concat(i.popup, " > .").concat(i.radio, " input:checked")) || e.querySelector(".".concat(i.popup, " > .").concat(i.radio, " input:first-child"));
        case "range":
          return e.querySelector(".".concat(i.popup, " > .").concat(i.range, " input"));
        default:
          return e.querySelector(".".concat(i.popup, " > .").concat(i.input));
      }
    },
    F = function F(e) {
      if (e.focus(), "file" !== e.type) {
        var _t4 = e.value;
        e.value = "", e.value = _t4;
      }
    },
    _ = function _(e, t, o) {
      e && t && ("string" == typeof t && (t = t.split(/\s+/).filter(Boolean)), t.forEach(function (t) {
        Array.isArray(e) ? e.forEach(function (e) {
          o ? e.classList.add(t) : e.classList.remove(t);
        }) : o ? e.classList.add(t) : e.classList.remove(t);
      }));
    },
    R = function R(e, t) {
      _(e, t, !0);
    },
    U = function U(e, t) {
      _(e, t, !1);
    },
    z = function z(e, t) {
      var o = Array.from(e.children);
      for (var _e2 = 0; _e2 < o.length; _e2++) {
        var _n = o[_e2];
        if (_n instanceof HTMLElement && q(_n, t)) return _n;
      }
    },
    W = function W(e, t, o) {
      o === "".concat(parseInt(o)) && (o = parseInt(o)), o || 0 === parseInt(o) ? e.style[t] = "number" == typeof o ? "".concat(o, "px") : o : e.style.removeProperty(t);
    },
    K = function K(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "flex";
      e && (e.style.display = t);
    },
    Y = function Y(e) {
      e && (e.style.display = "none");
    },
    Z = function Z(e, t, o, n) {
      var i = e.querySelector(t);
      i && (i.style[o] = n);
    },
    J = function J(e, t) {
      t ? K(e, arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "flex") : Y(e);
    },
    X = function X(e) {
      return !(!e || !(e.offsetWidth || e.offsetHeight || e.getClientRects().length));
    },
    G = function G(e) {
      return !!(e.scrollHeight > e.clientHeight);
    },
    Q = function Q(e) {
      var t = window.getComputedStyle(e),
        o = parseFloat(t.getPropertyValue("animation-duration") || "0"),
        n = parseFloat(t.getPropertyValue("transition-duration") || "0");
      return o > 0 || n > 0;
    },
    ee = function ee(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
      var o = O();
      X(o) && (t && (o.style.transition = "none", o.style.width = "100%"), setTimeout(function () {
        o.style.transition = "width ".concat(e / 1e3, "s linear"), o.style.width = "0%";
      }, 10));
    },
    te = function te() {
      return "undefined" == typeof window || "undefined" == typeof document;
    },
    oe = "\n <div aria-labelledby=\"".concat(i.title, "\" aria-describedby=\"").concat(i["html-container"], "\" class=\"").concat(i.popup, "\" tabindex=\"-1\">\n   <button type=\"button\" class=\"").concat(i.close, "\"></button>\n   <ul class=\"").concat(i["progress-steps"], "\"></ul>\n   <div class=\"").concat(i.icon, "\"></div>\n   <img class=\"").concat(i.image, "\" />\n   <h2 class=\"").concat(i.title, "\" id=\"").concat(i.title, "\"></h2>\n   <div class=\"").concat(i["html-container"], "\" id=\"").concat(i["html-container"], "\"></div>\n   <input class=\"").concat(i.input, "\" />\n   <input type=\"file\" class=\"").concat(i.file, "\" />\n   <div class=\"").concat(i.range, "\">\n     <input type=\"range\" />\n     <output></output>\n   </div>\n   <select class=\"").concat(i.select, "\"></select>\n   <div class=\"").concat(i.radio, "\"></div>\n   <label for=\"").concat(i.checkbox, "\" class=\"").concat(i.checkbox, "\">\n     <input type=\"checkbox\" />\n     <span class=\"").concat(i.label, "\"></span>\n   </label>\n   <textarea class=\"").concat(i.textarea, "\"></textarea>\n   <div class=\"").concat(i["validation-message"], "\" id=\"").concat(i["validation-message"], "\"></div>\n   <div class=\"").concat(i.actions, "\">\n     <div class=\"").concat(i.loader, "\"></div>\n     <button type=\"button\" class=\"").concat(i.confirm, "\"></button>\n     <button type=\"button\" class=\"").concat(i.deny, "\"></button>\n     <button type=\"button\" class=\"").concat(i.cancel, "\"></button>\n   </div>\n   <div class=\"").concat(i.footer, "\"></div>\n   <div class=\"").concat(i["timer-progress-bar-container"], "\">\n     <div class=\"").concat(i["timer-progress-bar"], "\"></div>\n   </div>\n </div>\n").replace(/(^|\n)\s*/g, ""),
    ne = function ne() {
      e.currentInstance.resetValidationMessage();
    },
    ie = function ie(e) {
      var t = function () {
        var e = f();
        return !!e && (e.remove(), U([document.documentElement, document.body], [i["no-backdrop"], i["toast-shown"], i["has-column"]]), !0);
      }();
      if (te()) return void c("SweetAlert2 requires document to initialize");
      var o = document.createElement("div");
      o.className = i.container, t && R(o, i["no-transition"]), D(o, oe);
      var n = "string" == typeof (s = e.target) ? document.querySelector(s) : s;
      var s;
      n.appendChild(o), function (e) {
        var t = w();
        t.setAttribute("role", e.toast ? "alert" : "dialog"), t.setAttribute("aria-live", e.toast ? "polite" : "assertive"), e.toast || t.setAttribute("aria-modal", "true");
      }(e), function (e) {
        "rtl" === window.getComputedStyle(e).direction && R(f(), i.rtl);
      }(n), function () {
        var e = w(),
          t = z(e, i.input),
          o = z(e, i.file),
          n = e.querySelector(".".concat(i.range, " input")),
          s = e.querySelector(".".concat(i.range, " output")),
          r = z(e, i.select),
          a = e.querySelector(".".concat(i.checkbox, " input")),
          l = z(e, i.textarea);
        t.oninput = ne, o.onchange = ne, r.onchange = ne, a.onchange = ne, l.oninput = ne, n.oninput = function () {
          ne(), s.value = n.value;
        }, n.onchange = function () {
          ne(), s.value = n.value;
        };
      }();
    },
    se = function se(e, t) {
      e instanceof HTMLElement ? t.appendChild(e) : "object" == _typeof(e) ? re(e, t) : e && D(t, e);
    },
    re = function re(e, t) {
      e.jquery ? ae(t, e) : D(t, e.toString());
    },
    ae = function ae(e, t) {
      if (e.textContent = "", 0 in t) for (var _o2 = 0; (_o2 in t); _o2++) {
        e.appendChild(t[_o2].cloneNode(!0));
      } else e.appendChild(t.cloneNode(!0));
    },
    le = function () {
      if (te()) return !1;
      var e = document.createElement("div"),
        t = {
          WebkitAnimation: "webkitAnimationEnd",
          animation: "animationend"
        };
      for (var _o3 in t) {
        if (Object.prototype.hasOwnProperty.call(t, _o3) && void 0 !== e.style[_o3]) return t[_o3];
      }
      return !1;
    }(),
    ce = function ce(e, t) {
      var o = L(),
        n = T();
      t.showConfirmButton || t.showDenyButton || t.showCancelButton ? K(o) : Y(o), V(o, t, "actions"), function (e, t, o) {
        var n = E(),
          s = x(),
          r = $();
        ue(n, "confirm", o), ue(s, "deny", o), ue(r, "cancel", o), function (e, t, o, n) {
          if (!n.buttonsStyling) return void U([e, t, o], i.styled);
          R([e, t, o], i.styled), n.confirmButtonColor && (e.style.backgroundColor = n.confirmButtonColor, R(e, i["default-outline"]));
          n.denyButtonColor && (t.style.backgroundColor = n.denyButtonColor, R(t, i["default-outline"]));
          n.cancelButtonColor && (o.style.backgroundColor = n.cancelButtonColor, R(o, i["default-outline"]));
        }(n, s, r, o), o.reverseButtons && (o.toast ? (e.insertBefore(r, n), e.insertBefore(s, n)) : (e.insertBefore(r, t), e.insertBefore(s, t), e.insertBefore(n, t)));
      }(o, n, t), D(n, t.loaderHtml), V(n, t, "loader");
    };
  function ue(e, t, o) {
    J(e, o["show".concat(a(t), "Button")], "inline-block"), D(e, o["".concat(t, "ButtonText")]), e.setAttribute("aria-label", o["".concat(t, "ButtonAriaLabel")]), e.className = i[t], V(e, o, "".concat(t, "Button")), R(e, o["".concat(t, "ButtonClass")]);
  }
  var de = function de(e, t) {
    var o = f();
    o && (!function (e, t) {
      "string" == typeof t ? e.style.background = t : t || R([document.documentElement, document.body], i["no-backdrop"]);
    }(o, t.backdrop), function (e, t) {
      t in i ? R(e, i[t]) : (l('The "position" parameter is not valid, defaulting to "center"'), R(e, i.center));
    }(o, t.position), function (e, t) {
      if (t && "string" == typeof t) {
        var _o4 = "grow-".concat(t);
        _o4 in i && R(e, i[_o4]);
      }
    }(o, t.grow), V(o, t, "container"));
  };
  var pe = ["input", "file", "range", "select", "radio", "checkbox", "textarea"],
    me = function me(e) {
      if (!ve[e.input]) return void c("Unexpected type of input! Expected \"text\", \"email\", \"password\", \"number\", \"tel\", \"select\", \"radio\", \"checkbox\", \"textarea\", \"file\" or \"url\", got \"".concat(e.input, "\""));
      var t = ye(e.input),
        o = ve[e.input](t, e);
      K(t), e.inputAutoFocus && setTimeout(function () {
        F(o);
      });
    },
    ge = function ge(e, t) {
      var o = N(w(), e);
      if (o) {
        (function (e) {
          for (var _t5 = 0; _t5 < e.attributes.length; _t5++) {
            var _o5 = e.attributes[_t5].name;
            ["type", "value", "style"].includes(_o5) || e.removeAttribute(_o5);
          }
        })(o);
        for (var _e3 in t) {
          o.setAttribute(_e3, t[_e3]);
        }
      }
    },
    he = function he(e) {
      var t = ye(e.input);
      "object" == _typeof(e.customClass) && R(t, e.customClass.input);
    },
    fe = function fe(e, t) {
      e.placeholder && !t.inputPlaceholder || (e.placeholder = t.inputPlaceholder);
    },
    be = function be(e, t, o) {
      if (o.inputLabel) {
        e.id = i.input;
        var _n2 = document.createElement("label"),
          _s = i["input-label"];
        _n2.setAttribute("for", e.id), _n2.className = _s, "object" == _typeof(o.customClass) && R(_n2, o.customClass.inputLabel), _n2.innerText = o.inputLabel, t.insertAdjacentElement("beforebegin", _n2);
      }
    },
    ye = function ye(e) {
      return z(w(), i[e] || i.input);
    },
    we = function we(e, t) {
      ["string", "number"].includes(_typeof(t)) ? e.value = "".concat(t) : h(t) || l("Unexpected type of inputValue! Expected \"string\", \"number\" or \"Promise\", got \"".concat(_typeof(t), "\""));
    },
    ve = {};
  ve.text = ve.email = ve.password = ve.number = ve.tel = ve.url = function (e, t) {
    return we(e, t.inputValue), be(e, e, t), fe(e, t), e.type = t.input, e;
  }, ve.file = function (e, t) {
    return be(e, e, t), fe(e, t), e;
  }, ve.range = function (e, t) {
    var o = e.querySelector("input"),
      n = e.querySelector("output");
    return we(o, t.inputValue), o.type = t.input, we(n, t.inputValue), be(o, e, t), e;
  }, ve.select = function (e, t) {
    if (e.textContent = "", t.inputPlaceholder) {
      var _o6 = document.createElement("option");
      D(_o6, t.inputPlaceholder), _o6.value = "", _o6.disabled = !0, _o6.selected = !0, e.appendChild(_o6);
    }
    return be(e, e, t), e;
  }, ve.radio = function (e) {
    return e.textContent = "", e;
  }, ve.checkbox = function (e, t) {
    var o = N(w(), "checkbox");
    o.value = "1", o.id = i.checkbox, o.checked = Boolean(t.inputValue);
    var n = e.querySelector("span");
    return D(n, t.inputPlaceholder), o;
  }, ve.textarea = function (e, t) {
    we(e, t.inputValue), fe(e, t), be(e, e, t);
    return setTimeout(function () {
      if ("MutationObserver" in window) {
        var _t6 = parseInt(window.getComputedStyle(w()).width);
        new MutationObserver(function () {
          var o = e.offsetWidth + (n = e, parseInt(window.getComputedStyle(n).marginLeft) + parseInt(window.getComputedStyle(n).marginRight));
          var n;
          w().style.width = o > _t6 ? "".concat(o, "px") : null;
        }).observe(e, {
          attributes: !0,
          attributeFilter: ["style"]
        });
      }
    }), e;
  };
  var Ce = function Ce(e, t) {
      var n = A();
      n && (V(n, t, "htmlContainer"), t.html ? (se(t.html, n), K(n, "block")) : t.text ? (n.textContent = t.text, K(n, "block")) : Y(n), function (e, t) {
        var n = w(),
          s = o.innerParams.get(e),
          r = !s || t.input !== s.input;
        pe.forEach(function (e) {
          var o = z(n, i[e]);
          ge(e, t.inputAttributes), o.className = i[e], r && Y(o);
        }), t.input && (r && me(t), he(t));
      }(e, t));
    },
    Ae = function Ae(e, t) {
      for (var _o7 in s) {
        t.icon !== _o7 && U(e, s[_o7]);
      }
      R(e, s[t.icon]), Pe(e, t), ke(), V(e, t, "icon");
    },
    ke = function ke() {
      var e = w(),
        t = window.getComputedStyle(e).getPropertyValue("background-color"),
        o = e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix");
      for (var _e4 = 0; _e4 < o.length; _e4++) {
        o[_e4].style.backgroundColor = t;
      }
    },
    Be = function Be(e, t) {
      var o,
        n = e.innerHTML;
      if (t.iconHtml) o = Ee(t.iconHtml);else if ("success" === t.icon) o = '\n  <div class="swal2-success-circular-line-left"></div>\n  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>\n  <div class="swal2-success-ring"></div> <div class="swal2-success-fix"></div>\n  <div class="swal2-success-circular-line-right"></div>\n', n = n.replace(/ style=".*?"/g, "");else if ("error" === t.icon) o = '\n  <span class="swal2-x-mark">\n    <span class="swal2-x-mark-line-left"></span>\n    <span class="swal2-x-mark-line-right"></span>\n  </span>\n';else {
        o = Ee({
          question: "?",
          warning: "!",
          info: "i"
        }[t.icon]);
      }
      n.trim() !== o.trim() && D(e, o);
    },
    Pe = function Pe(e, t) {
      if (t.iconColor) {
        e.style.color = t.iconColor, e.style.borderColor = t.iconColor;
        for (var _i = 0, _arr = [".swal2-success-line-tip", ".swal2-success-line-long", ".swal2-x-mark-line-left", ".swal2-x-mark-line-right"]; _i < _arr.length; _i++) {
          var _o8 = _arr[_i];
          Z(e, _o8, "backgroundColor", t.iconColor);
        }
        Z(e, ".swal2-success-ring", "borderColor", t.iconColor);
      }
    },
    Ee = function Ee(e) {
      return "<div class=\"".concat(i["icon-content"], "\">").concat(e, "</div>");
    },
    $e = function $e(e, t) {
      var o = t.showClass || {};
      e.className = "".concat(i.popup, " ").concat(X(e) ? o.popup : ""), t.toast ? (R([document.documentElement, document.body], i["toast-shown"]), R(e, i.toast)) : R(e, i.modal), V(e, t, "popup"), "string" == typeof t.customClass && R(e, t.customClass), t.icon && R(e, i["icon-".concat(t.icon)]);
    },
    xe = function xe(e) {
      var t = document.createElement("li");
      return R(t, i["progress-step"]), D(t, e), t;
    },
    Te = function Te(e) {
      var t = document.createElement("li");
      return R(t, i["progress-step-line"]), e.progressStepsDistance && W(t, "width", e.progressStepsDistance), t;
    },
    Le = function Le(e, t) {
      (function (e, t) {
        var o = f(),
          n = w();
        if (o && n) {
          if (t.toast) {
            W(o, "width", t.width), n.style.width = "100%";
            var _e5 = T();
            _e5 && n.insertBefore(_e5, v());
          } else W(n, "width", t.width);
          W(n, "padding", t.padding), t.color && (n.style.color = t.color), t.background && (n.style.background = t.background), Y(P()), $e(n, t);
        }
      })(0, t), de(0, t), function (e, t) {
        var o = B();
        if (!o) return;
        var n = t.progressSteps,
          s = t.currentProgressStep;
        n && 0 !== n.length && void 0 !== s ? (K(o), o.textContent = "", s >= n.length && l("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"), n.forEach(function (e, r) {
          var a = xe(e);
          if (o.appendChild(a), r === s && R(a, i["active-progress-step"]), r !== n.length - 1) {
            var _e6 = Te(t);
            o.appendChild(_e6);
          }
        })) : Y(o);
      }(0, t), function (e, t) {
        var n = o.innerParams.get(e),
          i = v();
        if (n && t.icon === n.icon) return Be(i, t), void Ae(i, t);
        if (t.icon || t.iconHtml) {
          if (t.icon && -1 === Object.keys(s).indexOf(t.icon)) return c("Unknown icon! Expected \"success\", \"error\", \"warning\", \"info\" or \"question\", got \"".concat(t.icon, "\"")), void Y(i);
          K(i), Be(i, t), Ae(i, t), R(i, t.showClass.icon);
        } else Y(i);
      }(e, t), function (e, t) {
        var o = k();
        o && (t.imageUrl ? (K(o, ""), o.setAttribute("src", t.imageUrl), o.setAttribute("alt", t.imageAlt || ""), W(o, "width", t.imageWidth), W(o, "height", t.imageHeight), o.className = i.image, V(o, t, "image")) : Y(o));
      }(0, t), function (e, t) {
        var o = C();
        o && (J(o, t.title || t.titleText, "block"), t.title && se(t.title, o), t.titleText && (o.innerText = t.titleText), V(o, t, "title"));
      }(0, t), function (e, t) {
        var o = M();
        o && (D(o, t.closeButtonHtml || ""), V(o, t, "closeButton"), J(o, t.showCloseButton), o.setAttribute("aria-label", t.closeButtonAriaLabel || ""));
      }(0, t), Ce(e, t), ce(0, t), function (e, t) {
        var o = S();
        o && (J(o, t.footer), t.footer && se(t.footer, o), V(o, t, "footer"));
      }(0, t);
      var n = w();
      "function" == typeof t.didRender && n && t.didRender(n);
    },
    Se = function Se() {
      return E() && E().click();
    },
    Oe = Object.freeze({
      cancel: "cancel",
      backdrop: "backdrop",
      close: "close",
      esc: "esc",
      timer: "timer"
    }),
    Me = function Me(e) {
      e.keydownTarget && e.keydownHandlerAdded && (e.keydownTarget.removeEventListener("keydown", e.keydownHandler, {
        capture: e.keydownListenerCapture
      }), e.keydownHandlerAdded = !1);
    },
    je = function je(e, t) {
      var o = j();
      if (o.length) return (e += t) === o.length ? e = 0 : -1 === e && (e = o.length - 1), void o[e].focus();
      w().focus();
    },
    Ie = ["ArrowRight", "ArrowDown"],
    He = ["ArrowLeft", "ArrowUp"],
    De = function De(e, t, n) {
      var i = o.innerParams.get(e);
      i && (t.isComposing || 229 === t.keyCode || (i.stopKeydownPropagation && t.stopPropagation(), "Enter" === t.key ? qe(e, t, i) : "Tab" === t.key ? Ve(t) : [].concat(Ie, He).includes(t.key) ? Ne(t.key) : "Escape" === t.key && Fe(t, i, n)));
    },
    qe = function qe(e, t, o) {
      if (p(o.allowEnterKey) && t.target && e.getInput() && t.target instanceof HTMLElement && t.target.outerHTML === e.getInput().outerHTML) {
        if (["textarea", "file"].includes(o.input)) return;
        Se(), t.preventDefault();
      }
    },
    Ve = function Ve(e) {
      var t = e.target,
        o = j();
      var n = -1;
      for (var _e7 = 0; _e7 < o.length; _e7++) {
        if (t === o[_e7]) {
          n = _e7;
          break;
        }
      }
      e.shiftKey ? je(n, -1) : je(n, 1), e.stopPropagation(), e.preventDefault();
    },
    Ne = function Ne(e) {
      var t = [E(), x(), $()];
      if (document.activeElement instanceof HTMLElement && !t.includes(document.activeElement)) return;
      var o = Ie.includes(e) ? "nextElementSibling" : "previousElementSibling";
      var n = document.activeElement;
      for (var _e8 = 0; _e8 < L().children.length; _e8++) {
        if (n = n[o], !n) return;
        if (n instanceof HTMLButtonElement && X(n)) break;
      }
      n instanceof HTMLButtonElement && n.focus();
    },
    Fe = function Fe(e, t, o) {
      p(t.allowEscapeKey) && (e.preventDefault(), o(Oe.esc));
    };
  var _e = {
    swalPromiseResolve: new WeakMap(),
    swalPromiseReject: new WeakMap()
  };
  var Re = function Re() {
      Array.from(document.body.children).forEach(function (e) {
        e.hasAttribute("data-previous-aria-hidden") ? (e.setAttribute("aria-hidden", e.getAttribute("data-previous-aria-hidden") || ""), e.removeAttribute("data-previous-aria-hidden")) : e.removeAttribute("aria-hidden");
      });
    },
    Ue = function Ue() {
      var e = navigator.userAgent,
        t = !!e.match(/iPad/i) || !!e.match(/iPhone/i),
        o = !!e.match(/WebKit/i);
      if (t && o && !e.match(/CriOS/i)) {
        var _e9 = 44;
        w().scrollHeight > window.innerHeight - _e9 && (f().style.paddingBottom = "".concat(_e9, "px"));
      }
    },
    ze = function ze() {
      var e = f();
      var t;
      e.ontouchstart = function (e) {
        t = We(e);
      }, e.ontouchmove = function (e) {
        t && (e.preventDefault(), e.stopPropagation());
      };
    },
    We = function We(e) {
      var t = e.target,
        o = f();
      return !Ke(e) && !Ye(e) && (t === o || !G(o) && t instanceof HTMLElement && "INPUT" !== t.tagName && "TEXTAREA" !== t.tagName && (!G(A()) || !A().contains(t)));
    },
    Ke = function Ke(e) {
      return e.touches && e.touches.length && "stylus" === e.touches[0].touchType;
    },
    Ye = function Ye(e) {
      return e.touches && e.touches.length > 1;
    };
  var Ze = null;
  var Je = function Je() {
    null === Ze && document.body.scrollHeight > window.innerHeight && (Ze = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")), document.body.style.paddingRight = "".concat(Ze + function () {
      var e = document.createElement("div");
      e.className = i["scrollbar-measure"], document.body.appendChild(e);
      var t = e.getBoundingClientRect().width - e.clientWidth;
      return document.body.removeChild(e), t;
    }(), "px"));
  };
  function Xe(o, n, s, r) {
    H() ? st(o, r) : (t(s).then(function () {
      return st(o, r);
    }), Me(e));
    /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ? (n.setAttribute("style", "display:none !important"), n.removeAttribute("class"), n.innerHTML = "") : n.remove(), I() && (null !== Ze && (document.body.style.paddingRight = "".concat(Ze, "px"), Ze = null), function () {
      if (q(document.body, i.iosfix)) {
        var _e10 = parseInt(document.body.style.top, 10);
        U(document.body, i.iosfix), document.body.style.top = "", document.body.scrollTop = -1 * _e10;
      }
    }(), Re()), U([document.documentElement, document.body], [i.shown, i["height-auto"], i["no-backdrop"], i["toast-shown"]]);
  }
  function Ge(e) {
    e = ot(e);
    var t = _e.swalPromiseResolve.get(this),
      o = Qe(this);
    this.isAwaitingPromise ? e.isDismissed || (tt(this), t(e)) : o && t(e);
  }
  var Qe = function Qe(e) {
    var t = w();
    if (!t) return !1;
    var n = o.innerParams.get(e);
    if (!n || q(t, n.hideClass.popup)) return !1;
    U(t, n.showClass.popup), R(t, n.hideClass.popup);
    var i = f();
    return U(i, n.showClass.backdrop), R(i, n.hideClass.backdrop), nt(e, t, n), !0;
  };
  function et(e) {
    var t = _e.swalPromiseReject.get(this);
    tt(this), t && t(e);
  }
  var tt = function tt(e) {
      e.isAwaitingPromise && (delete e.isAwaitingPromise, o.innerParams.get(e) || e._destroy());
    },
    ot = function ot(e) {
      return void 0 === e ? {
        isConfirmed: !1,
        isDenied: !1,
        isDismissed: !0
      } : Object.assign({
        isConfirmed: !1,
        isDenied: !1,
        isDismissed: !1
      }, e);
    },
    nt = function nt(e, t, o) {
      var n = f(),
        i = le && Q(t);
      "function" == typeof o.willClose && o.willClose(t), i ? it(e, t, n, o.returnFocus, o.didClose) : Xe(e, n, o.returnFocus, o.didClose);
    },
    it = function it(t, o, n, i, s) {
      e.swalCloseEventFinishedCallback = Xe.bind(null, t, n, i, s), o.addEventListener(le, function (t) {
        t.target === o && (e.swalCloseEventFinishedCallback(), delete e.swalCloseEventFinishedCallback);
      });
    },
    st = function st(e, t) {
      setTimeout(function () {
        "function" == typeof t && t.bind(e.params)(), e._destroy && e._destroy();
      });
    },
    rt = function rt(e) {
      var t = w();
      t || new Do(), t = w();
      var o = T();
      H() ? Y(v()) : at(t, e), K(o), t.setAttribute("data-loading", "true"), t.setAttribute("aria-busy", "true"), t.focus();
    },
    at = function at(e, t) {
      var o = L(),
        n = T();
      !t && X(E()) && (t = E()), K(o), t && (Y(t), n.setAttribute("data-button-to-replace", t.className)), n.parentNode.insertBefore(n, t), R([e, o], i.loading);
    },
    lt = function lt(e) {
      return e.checked ? 1 : 0;
    },
    ct = function ct(e) {
      return e.checked ? e.value : null;
    },
    ut = function ut(e) {
      return e.files.length ? null !== e.getAttribute("multiple") ? e.files : e.files[0] : null;
    },
    dt = function dt(e, t) {
      var o = w(),
        n = function n(e) {
          mt[t.input](o, gt(e), t);
        };
      m(t.inputOptions) || h(t.inputOptions) ? (rt(E()), g(t.inputOptions).then(function (t) {
        e.hideLoading(), n(t);
      })) : "object" == _typeof(t.inputOptions) ? n(t.inputOptions) : c("Unexpected type of inputOptions! Expected object, Map or Promise, got " + _typeof(t.inputOptions));
    },
    pt = function pt(e, t) {
      var o = e.getInput();
      Y(o), g(t.inputValue).then(function (n) {
        o.value = "number" === t.input ? "".concat(parseFloat(n) || 0) : "".concat(n), K(o), o.focus(), e.hideLoading();
      })["catch"](function (t) {
        c("Error in inputValue promise: ".concat(t)), o.value = "", K(o), o.focus(), e.hideLoading();
      });
    },
    mt = {
      select: function select(e, t, o) {
        var n = z(e, i.select),
          s = function s(e, t, n) {
            var i = document.createElement("option");
            i.value = n, D(i, t), i.selected = ht(n, o.inputValue), e.appendChild(i);
          };
        t.forEach(function (e) {
          var t = e[0],
            o = e[1];
          if (Array.isArray(o)) {
            var _e11 = document.createElement("optgroup");
            _e11.label = t, _e11.disabled = !1, n.appendChild(_e11), o.forEach(function (t) {
              return s(_e11, t[1], t[0]);
            });
          } else s(n, o, t);
        }), n.focus();
      },
      radio: function radio(e, t, o) {
        var n = z(e, i.radio);
        t.forEach(function (e) {
          var t = e[0],
            s = e[1],
            r = document.createElement("input"),
            a = document.createElement("label");
          r.type = "radio", r.name = i.radio, r.value = t, ht(t, o.inputValue) && (r.checked = !0);
          var l = document.createElement("span");
          D(l, s), l.className = i.label, a.appendChild(r), a.appendChild(l), n.appendChild(a);
        });
        var s = n.querySelectorAll("input");
        s.length && s[0].focus();
      }
    },
    gt = function gt(e) {
      var t = [];
      return "undefined" != typeof Map && e instanceof Map ? e.forEach(function (e, o) {
        var n = e;
        "object" == _typeof(n) && (n = gt(n)), t.push([o, n]);
      }) : Object.keys(e).forEach(function (o) {
        var n = e[o];
        "object" == _typeof(n) && (n = gt(n)), t.push([o, n]);
      }), t;
    },
    ht = function ht(e, t) {
      return t && t.toString() === e.toString();
    },
    ft = function ft(e, t) {
      var n = o.innerParams.get(e);
      if (!n.input) return void c("The \"input\" parameter is needed to be set when using returnInputValueOn".concat(a(t)));
      var i = function (e, t) {
        var o = e.getInput();
        if (!o) return null;
        switch (t.input) {
          case "checkbox":
            return lt(o);
          case "radio":
            return ct(o);
          case "file":
            return ut(o);
          default:
            return t.inputAutoTrim ? o.value.trim() : o.value;
        }
      }(e, n);
      n.inputValidator ? bt(e, i, t) : e.getInput().checkValidity() ? "deny" === t ? yt(e, i) : Ct(e, i) : (e.enableButtons(), e.showValidationMessage(n.validationMessage));
    },
    bt = function bt(e, t, n) {
      var i = o.innerParams.get(e);
      e.disableInput();
      Promise.resolve().then(function () {
        return g(i.inputValidator(t, i.validationMessage));
      }).then(function (o) {
        e.enableButtons(), e.enableInput(), o ? e.showValidationMessage(o) : "deny" === n ? yt(e, t) : Ct(e, t);
      });
    },
    yt = function yt(e, t) {
      var n = o.innerParams.get(e || void 0);
      if (n.showLoaderOnDeny && rt(x()), n.preDeny) {
        e.isAwaitingPromise = !0;
        Promise.resolve().then(function () {
          return g(n.preDeny(t, n.validationMessage));
        }).then(function (o) {
          !1 === o ? (e.hideLoading(), tt(e)) : e.close({
            isDenied: !0,
            value: void 0 === o ? t : o
          });
        })["catch"](function (t) {
          return vt(e || void 0, t);
        });
      } else e.close({
        isDenied: !0,
        value: t
      });
    },
    wt = function wt(e, t) {
      e.close({
        isConfirmed: !0,
        value: t
      });
    },
    vt = function vt(e, t) {
      e.rejectPromise(t);
    },
    Ct = function Ct(e, t) {
      var n = o.innerParams.get(e || void 0);
      if (n.showLoaderOnConfirm && rt(), n.preConfirm) {
        e.resetValidationMessage(), e.isAwaitingPromise = !0;
        Promise.resolve().then(function () {
          return g(n.preConfirm(t, n.validationMessage));
        }).then(function (o) {
          X(P()) || !1 === o ? (e.hideLoading(), tt(e)) : wt(e, void 0 === o ? t : o);
        })["catch"](function (t) {
          return vt(e || void 0, t);
        });
      } else wt(e, t);
    };
  function At() {
    var e = o.innerParams.get(this);
    if (!e) return;
    var t = o.domCache.get(this);
    Y(t.loader), H() ? e.icon && K(v()) : kt(t), U([t.popup, t.actions], i.loading), t.popup.removeAttribute("aria-busy"), t.popup.removeAttribute("data-loading"), t.confirmButton.disabled = !1, t.denyButton.disabled = !1, t.cancelButton.disabled = !1;
  }
  var kt = function kt(e) {
    var t = e.popup.getElementsByClassName(e.loader.getAttribute("data-button-to-replace"));
    t.length ? K(t[0], "inline-block") : X(E()) || X(x()) || X($()) || Y(e.actions);
  };
  function Bt() {
    var e = o.innerParams.get(this),
      t = o.domCache.get(this);
    return t ? N(t.popup, e.input) : null;
  }
  function Pt(e, t, n) {
    var i = o.domCache.get(e);
    t.forEach(function (e) {
      i[e].disabled = n;
    });
  }
  function Et(e, t) {
    if (e) if ("radio" === e.type) {
      var _o9 = e.parentNode.parentNode.querySelectorAll("input");
      for (var _e12 = 0; _e12 < _o9.length; _e12++) {
        _o9[_e12].disabled = t;
      }
    } else e.disabled = t;
  }
  function $t() {
    Pt(this, ["confirmButton", "denyButton", "cancelButton"], !1);
  }
  function xt() {
    Pt(this, ["confirmButton", "denyButton", "cancelButton"], !0);
  }
  function Tt() {
    Et(this.getInput(), !1);
  }
  function Lt() {
    Et(this.getInput(), !0);
  }
  function St(e) {
    var t = o.domCache.get(this),
      n = o.innerParams.get(this);
    D(t.validationMessage, e), t.validationMessage.className = i["validation-message"], n.customClass && n.customClass.validationMessage && R(t.validationMessage, n.customClass.validationMessage), K(t.validationMessage);
    var s = this.getInput();
    s && (s.setAttribute("aria-invalid", !0), s.setAttribute("aria-describedby", i["validation-message"]), F(s), R(s, i.inputerror));
  }
  function Ot() {
    var e = o.domCache.get(this);
    e.validationMessage && Y(e.validationMessage);
    var t = this.getInput();
    t && (t.removeAttribute("aria-invalid"), t.removeAttribute("aria-describedby"), U(t, i.inputerror));
  }
  var Mt = {
      title: "",
      titleText: "",
      text: "",
      html: "",
      footer: "",
      icon: void 0,
      iconColor: void 0,
      iconHtml: void 0,
      template: void 0,
      toast: !1,
      showClass: {
        popup: "swal2-show",
        backdrop: "swal2-backdrop-show",
        icon: "swal2-icon-show"
      },
      hideClass: {
        popup: "swal2-hide",
        backdrop: "swal2-backdrop-hide",
        icon: "swal2-icon-hide"
      },
      customClass: {},
      target: "body",
      color: void 0,
      backdrop: !0,
      heightAuto: !0,
      allowOutsideClick: !0,
      allowEscapeKey: !0,
      allowEnterKey: !0,
      stopKeydownPropagation: !0,
      keydownListenerCapture: !1,
      showConfirmButton: !0,
      showDenyButton: !1,
      showCancelButton: !1,
      preConfirm: void 0,
      preDeny: void 0,
      confirmButtonText: "OK",
      confirmButtonAriaLabel: "",
      confirmButtonColor: void 0,
      denyButtonText: "No",
      denyButtonAriaLabel: "",
      denyButtonColor: void 0,
      cancelButtonText: "Cancel",
      cancelButtonAriaLabel: "",
      cancelButtonColor: void 0,
      buttonsStyling: !0,
      reverseButtons: !1,
      focusConfirm: !0,
      focusDeny: !1,
      focusCancel: !1,
      returnFocus: !0,
      showCloseButton: !1,
      closeButtonHtml: "&times;",
      closeButtonAriaLabel: "Close this dialog",
      loaderHtml: "",
      showLoaderOnConfirm: !1,
      showLoaderOnDeny: !1,
      imageUrl: void 0,
      imageWidth: void 0,
      imageHeight: void 0,
      imageAlt: "",
      timer: void 0,
      timerProgressBar: !1,
      width: void 0,
      padding: void 0,
      background: void 0,
      input: void 0,
      inputPlaceholder: "",
      inputLabel: "",
      inputValue: "",
      inputOptions: {},
      inputAutoFocus: !0,
      inputAutoTrim: !0,
      inputAttributes: {},
      inputValidator: void 0,
      returnInputValueOnDeny: !1,
      validationMessage: void 0,
      grow: !1,
      position: "center",
      progressSteps: [],
      currentProgressStep: void 0,
      progressStepsDistance: void 0,
      willOpen: void 0,
      didOpen: void 0,
      didRender: void 0,
      willClose: void 0,
      didClose: void 0,
      didDestroy: void 0,
      scrollbarPadding: !0
    },
    jt = ["allowEscapeKey", "allowOutsideClick", "background", "buttonsStyling", "cancelButtonAriaLabel", "cancelButtonColor", "cancelButtonText", "closeButtonAriaLabel", "closeButtonHtml", "color", "confirmButtonAriaLabel", "confirmButtonColor", "confirmButtonText", "currentProgressStep", "customClass", "denyButtonAriaLabel", "denyButtonColor", "denyButtonText", "didClose", "didDestroy", "footer", "hideClass", "html", "icon", "iconColor", "iconHtml", "imageAlt", "imageHeight", "imageUrl", "imageWidth", "preConfirm", "preDeny", "progressSteps", "returnFocus", "reverseButtons", "showCancelButton", "showCloseButton", "showConfirmButton", "showDenyButton", "text", "title", "titleText", "willClose"],
    It = {},
    Ht = ["allowOutsideClick", "allowEnterKey", "backdrop", "focusConfirm", "focusDeny", "focusCancel", "returnFocus", "heightAuto", "keydownListenerCapture"],
    Dt = function Dt(e) {
      return Object.prototype.hasOwnProperty.call(Mt, e);
    },
    qt = function qt(e) {
      return -1 !== jt.indexOf(e);
    },
    Vt = function Vt(e) {
      return It[e];
    },
    Nt = function Nt(e) {
      Dt(e) || l("Unknown parameter \"".concat(e, "\""));
    },
    Ft = function Ft(e) {
      Ht.includes(e) && l("The parameter \"".concat(e, "\" is incompatible with toasts"));
    },
    _t = function _t(e) {
      var t = Vt(e);
      t && d(e, t);
    };
  function Rt(e) {
    var t = w(),
      n = o.innerParams.get(this);
    if (!t || q(t, n.hideClass.popup)) return void l("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
    var i = Ut(e),
      s = Object.assign({}, n, i);
    Le(this, s), o.innerParams.set(this, s), Object.defineProperties(this, {
      params: {
        value: Object.assign({}, this.params, e),
        writable: !1,
        enumerable: !0
      }
    });
  }
  var Ut = function Ut(e) {
    var t = {};
    return Object.keys(e).forEach(function (o) {
      qt(o) ? t[o] = e[o] : l("Invalid parameter to update: ".concat(o));
    }), t;
  };
  function zt() {
    var t = o.domCache.get(this),
      n = o.innerParams.get(this);
    n ? (t.popup && e.swalCloseEventFinishedCallback && (e.swalCloseEventFinishedCallback(), delete e.swalCloseEventFinishedCallback), "function" == typeof n.didDestroy && n.didDestroy(), Wt(this)) : Kt(this);
  }
  var Wt = function Wt(t) {
      Kt(t), delete t.params, delete e.keydownHandler, delete e.keydownTarget, delete e.currentInstance;
    },
    Kt = function Kt(e) {
      e.isAwaitingPromise ? (Yt(o, e), e.isAwaitingPromise = !0) : (Yt(_e, e), Yt(o, e), delete e.isAwaitingPromise, delete e.disableButtons, delete e.enableButtons, delete e.getInput, delete e.disableInput, delete e.enableInput, delete e.hideLoading, delete e.disableLoading, delete e.showValidationMessage, delete e.resetValidationMessage, delete e.close, delete e.closePopup, delete e.closeModal, delete e.closeToast, delete e.rejectPromise, delete e.update, delete e._destroy);
    },
    Yt = function Yt(e, t) {
      for (var _o10 in e) {
        e[_o10]["delete"](t);
      }
    };
  var Zt = Object.freeze({
    __proto__: null,
    _destroy: zt,
    close: Ge,
    closeModal: Ge,
    closePopup: Ge,
    closeToast: Ge,
    disableButtons: xt,
    disableInput: Lt,
    disableLoading: At,
    enableButtons: $t,
    enableInput: Tt,
    getInput: Bt,
    handleAwaitingPromise: tt,
    hideLoading: At,
    rejectPromise: et,
    resetValidationMessage: Ot,
    showValidationMessage: St,
    update: Rt
  });
  var Jt = function Jt(e, t, n) {
      t.popup.onclick = function () {
        var t = o.innerParams.get(e);
        t && (Xt(t) || t.timer || t.input) || n(Oe.close);
      };
    },
    Xt = function Xt(e) {
      return e.showConfirmButton || e.showDenyButton || e.showCancelButton || e.showCloseButton;
    };
  var Gt = !1;
  var Qt = function Qt(e) {
      e.popup.onmousedown = function () {
        e.container.onmouseup = function (t) {
          e.container.onmouseup = void 0, t.target === e.container && (Gt = !0);
        };
      };
    },
    eo = function eo(e) {
      e.container.onmousedown = function () {
        e.popup.onmouseup = function (t) {
          e.popup.onmouseup = void 0, (t.target === e.popup || e.popup.contains(t.target)) && (Gt = !0);
        };
      };
    },
    to = function to(e, t, n) {
      t.container.onclick = function (i) {
        var s = o.innerParams.get(e);
        Gt ? Gt = !1 : i.target === t.container && p(s.allowOutsideClick) && n(Oe.backdrop);
      };
    },
    oo = function oo(e) {
      return e instanceof Element || function (e) {
        return "object" == _typeof(e) && e.jquery;
      }(e);
    };
  var no = function no() {
      if (e.timeout) return function () {
        var e = O(),
          t = parseInt(window.getComputedStyle(e).width);
        e.style.removeProperty("transition"), e.style.width = "100%";
        var o = t / parseInt(window.getComputedStyle(e).width) * 100;
        e.style.width = "".concat(o, "%");
      }(), e.timeout.stop();
    },
    io = function io() {
      if (e.timeout) {
        var _t7 = e.timeout.start();
        return ee(_t7), _t7;
      }
    };
  var so = !1;
  var ro = {};
  var ao = function ao(e) {
    for (var _t8 = e.target; _t8 && _t8 !== document; _t8 = _t8.parentNode) {
      for (var _e13 in ro) {
        var _o11 = _t8.getAttribute(_e13);
        if (_o11) return void ro[_e13].fire({
          template: _o11
        });
      }
    }
  };
  var lo = Object.freeze({
    __proto__: null,
    argsToParams: function argsToParams(e) {
      var t = {};
      return "object" != _typeof(e[0]) || oo(e[0]) ? ["title", "html", "icon"].forEach(function (o, n) {
        var i = e[n];
        "string" == typeof i || oo(i) ? t[o] = i : void 0 !== i && c("Unexpected type of ".concat(o, "! Expected \"string\" or \"Element\", got ").concat(_typeof(i)));
      }) : Object.assign(t, e[0]), t;
    },
    bindClickHandler: function bindClickHandler() {
      ro[arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "data-swal-template"] = this, so || (document.body.addEventListener("click", ao), so = !0);
    },
    clickCancel: function clickCancel() {
      return $() && $().click();
    },
    clickConfirm: Se,
    clickDeny: function clickDeny() {
      return x() && x().click();
    },
    enableLoading: rt,
    fire: function fire() {
      for (var e = arguments.length, t = new Array(e), o = 0; o < e; o++) {
        t[o] = arguments[o];
      }
      return _construct(this, t);
    },
    getActions: L,
    getCancelButton: $,
    getCloseButton: M,
    getConfirmButton: E,
    getContainer: f,
    getDenyButton: x,
    getFocusableElements: j,
    getFooter: S,
    getHtmlContainer: A,
    getIcon: v,
    getIconContent: function getIconContent() {
      return y(i["icon-content"]);
    },
    getImage: k,
    getInputLabel: function getInputLabel() {
      return y(i["input-label"]);
    },
    getLoader: T,
    getPopup: w,
    getProgressSteps: B,
    getTimerLeft: function getTimerLeft() {
      return e.timeout && e.timeout.getTimerLeft();
    },
    getTimerProgressBar: O,
    getTitle: C,
    getValidationMessage: P,
    increaseTimer: function increaseTimer(t) {
      if (e.timeout) {
        var _o12 = e.timeout.increase(t);
        return ee(_o12, !0), _o12;
      }
    },
    isDeprecatedParameter: Vt,
    isLoading: function isLoading() {
      return w().hasAttribute("data-loading");
    },
    isTimerRunning: function isTimerRunning() {
      return !(!e.timeout || !e.timeout.isRunning());
    },
    isUpdatableParameter: qt,
    isValidParameter: Dt,
    isVisible: function isVisible() {
      return X(w());
    },
    mixin: function mixin(e) {
      return /*#__PURE__*/function (_this) {
        _inherits(_class, _this);
        var _super = _createSuper(_class);
        function _class() {
          _classCallCheck(this, _class);
          return _super.apply(this, arguments);
        }
        _createClass(_class, [{
          key: "_main",
          value: function _main(t, o) {
            return _get(_getPrototypeOf(_class.prototype), "_main", this).call(this, t, Object.assign({}, e, o));
          }
        }]);
        return _class;
      }(this);
    },
    resumeTimer: io,
    showLoading: rt,
    stopTimer: no,
    toggleTimer: function toggleTimer() {
      var t = e.timeout;
      return t && (t.running ? no() : io());
    }
  });
  var co = /*#__PURE__*/function () {
    function co(e, t) {
      _classCallCheck(this, co);
      this.callback = e, this.remaining = t, this.running = !1, this.start();
    }
    _createClass(co, [{
      key: "start",
      value: function start() {
        return this.running || (this.running = !0, this.started = new Date(), this.id = setTimeout(this.callback, this.remaining)), this.remaining;
      }
    }, {
      key: "stop",
      value: function stop() {
        return this.started && this.running && (this.running = !1, clearTimeout(this.id), this.remaining -= new Date().getTime() - this.started.getTime()), this.remaining;
      }
    }, {
      key: "increase",
      value: function increase(e) {
        var t = this.running;
        return t && this.stop(), this.remaining += e, t && this.start(), this.remaining;
      }
    }, {
      key: "getTimerLeft",
      value: function getTimerLeft() {
        return this.running && (this.stop(), this.start()), this.remaining;
      }
    }, {
      key: "isRunning",
      value: function isRunning() {
        return this.running;
      }
    }]);
    return co;
  }();
  var uo = ["swal-title", "swal-html", "swal-footer"],
    po = function po(e) {
      var t = {};
      return Array.from(e.querySelectorAll("swal-param")).forEach(function (e) {
        vo(e, ["name", "value"]);
        var o = e.getAttribute("name"),
          n = e.getAttribute("value");
        t[o] = "boolean" == typeof Mt[o] ? "false" !== n : "object" == _typeof(Mt[o]) ? JSON.parse(n) : n;
      }), t;
    },
    mo = function mo(e) {
      var t = {};
      return Array.from(e.querySelectorAll("swal-function-param")).forEach(function (e) {
        var o = e.getAttribute("name"),
          n = e.getAttribute("value");
        t[o] = new Function("return ".concat(n))();
      }), t;
    },
    go = function go(e) {
      var t = {};
      return Array.from(e.querySelectorAll("swal-button")).forEach(function (e) {
        vo(e, ["type", "color", "aria-label"]);
        var o = e.getAttribute("type");
        t["".concat(o, "ButtonText")] = e.innerHTML, t["show".concat(a(o), "Button")] = !0, e.hasAttribute("color") && (t["".concat(o, "ButtonColor")] = e.getAttribute("color")), e.hasAttribute("aria-label") && (t["".concat(o, "ButtonAriaLabel")] = e.getAttribute("aria-label"));
      }), t;
    },
    ho = function ho(e) {
      var t = {},
        o = e.querySelector("swal-image");
      return o && (vo(o, ["src", "width", "height", "alt"]), o.hasAttribute("src") && (t.imageUrl = o.getAttribute("src")), o.hasAttribute("width") && (t.imageWidth = o.getAttribute("width")), o.hasAttribute("height") && (t.imageHeight = o.getAttribute("height")), o.hasAttribute("alt") && (t.imageAlt = o.getAttribute("alt"))), t;
    },
    fo = function fo(e) {
      var t = {},
        o = e.querySelector("swal-icon");
      return o && (vo(o, ["type", "color"]), o.hasAttribute("type") && (t.icon = o.getAttribute("type")), o.hasAttribute("color") && (t.iconColor = o.getAttribute("color")), t.iconHtml = o.innerHTML), t;
    },
    bo = function bo(e) {
      var t = {},
        o = e.querySelector("swal-input");
      o && (vo(o, ["type", "label", "placeholder", "value"]), t.input = o.getAttribute("type") || "text", o.hasAttribute("label") && (t.inputLabel = o.getAttribute("label")), o.hasAttribute("placeholder") && (t.inputPlaceholder = o.getAttribute("placeholder")), o.hasAttribute("value") && (t.inputValue = o.getAttribute("value")));
      var n = Array.from(e.querySelectorAll("swal-input-option"));
      return n.length && (t.inputOptions = {}, n.forEach(function (e) {
        vo(e, ["value"]);
        var o = e.getAttribute("value"),
          n = e.innerHTML;
        t.inputOptions[o] = n;
      })), t;
    },
    yo = function yo(e, t) {
      var o = {};
      for (var _n3 in t) {
        var _i2 = t[_n3],
          _s2 = e.querySelector(_i2);
        _s2 && (vo(_s2, []), o[_i2.replace(/^swal-/, "")] = _s2.innerHTML.trim());
      }
      return o;
    },
    wo = function wo(e) {
      var t = uo.concat(["swal-param", "swal-function-param", "swal-button", "swal-image", "swal-icon", "swal-input", "swal-input-option"]);
      Array.from(e.children).forEach(function (e) {
        var o = e.tagName.toLowerCase();
        t.includes(o) || l("Unrecognized element <".concat(o, ">"));
      });
    },
    vo = function vo(e, t) {
      Array.from(e.attributes).forEach(function (o) {
        -1 === t.indexOf(o.name) && l(["Unrecognized attribute \"".concat(o.name, "\" on <").concat(e.tagName.toLowerCase(), ">."), "" + (t.length ? "Allowed attributes are: ".concat(t.join(", ")) : "To set the value, use HTML within the element.")]);
      });
    },
    Co = function Co(t) {
      var o = f(),
        n = w();
      "function" == typeof t.willOpen && t.willOpen(n);
      var s = window.getComputedStyle(document.body).overflowY;
      Po(o, n, t), setTimeout(function () {
        ko(o, n);
      }, 10), I() && (Bo(o, t.scrollbarPadding, s), Array.from(document.body.children).forEach(function (e) {
        e === f() || e.contains(f()) || (e.hasAttribute("aria-hidden") && e.setAttribute("data-previous-aria-hidden", e.getAttribute("aria-hidden") || ""), e.setAttribute("aria-hidden", "true"));
      })), H() || e.previousActiveElement || (e.previousActiveElement = document.activeElement), "function" == typeof t.didOpen && setTimeout(function () {
        return t.didOpen(n);
      }), U(o, i["no-transition"]);
    },
    Ao = function Ao(e) {
      var t = w();
      if (e.target !== t) return;
      var o = f();
      t.removeEventListener(le, Ao), o.style.overflowY = "auto";
    },
    ko = function ko(e, t) {
      le && Q(t) ? (e.style.overflowY = "hidden", t.addEventListener(le, Ao)) : e.style.overflowY = "auto";
    },
    Bo = function Bo(e, t, o) {
      (function () {
        if ((/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream || "MacIntel" === navigator.platform && navigator.maxTouchPoints > 1) && !q(document.body, i.iosfix)) {
          var _e14 = document.body.scrollTop;
          document.body.style.top = -1 * _e14 + "px", R(document.body, i.iosfix), ze(), Ue();
        }
      })(), t && "hidden" !== o && Je(), setTimeout(function () {
        e.scrollTop = 0;
      });
    },
    Po = function Po(e, t, o) {
      R(e, o.showClass.backdrop), t.style.setProperty("opacity", "0", "important"), K(t, "grid"), setTimeout(function () {
        R(t, o.showClass.popup), t.style.removeProperty("opacity");
      }, 10), R([document.documentElement, document.body], i.shown), o.heightAuto && o.backdrop && !o.toast && R([document.documentElement, document.body], i["height-auto"]);
    };
  var Eo = {
    email: function email(e, t) {
      return /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]{2,24}$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid email address");
    },
    url: function url(e, t) {
      return /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid URL");
    }
  };
  function $o(e) {
    !function (e) {
      e.inputValidator || Object.keys(Eo).forEach(function (t) {
        e.input === t && (e.inputValidator = Eo[t]);
      });
    }(e), e.showLoaderOnConfirm && !e.preConfirm && l("showLoaderOnConfirm is set to true, but preConfirm is not defined.\nshowLoaderOnConfirm should be used together with preConfirm, see usage example:\nhttps://sweetalert2.github.io/#ajax-request"), function (e) {
      (!e.target || "string" == typeof e.target && !document.querySelector(e.target) || "string" != typeof e.target && !e.target.appendChild) && (l('Target parameter is not valid, defaulting to "body"'), e.target = "body");
    }(e), "string" == typeof e.title && (e.title = e.title.split("\n").join("<br />")), ie(e);
  }
  var xo;
  var To = /*#__PURE__*/function () {
    function To() {
      _classCallCheck(this, To);
      if ("undefined" == typeof window) return;
      xo = this;
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
        t[n] = arguments[n];
      }
      var i = Object.freeze(this.constructor.argsToParams(t));
      this.params = i, this.isAwaitingPromise = !1;
      var s = xo._main(xo.params);
      o.promise.set(this, s);
    }
    _createClass(To, [{
      key: "_main",
      value: function _main(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        (function (e) {
          !1 === e.backdrop && e.allowOutsideClick && l('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`');
          for (var _t9 in e) {
            Nt(_t9), e.toast && Ft(_t9), _t(_t9);
          }
        })(Object.assign({}, n, t)), e.currentInstance && (e.currentInstance._destroy(), I() && Re()), e.currentInstance = xo;
        var i = So(t, n);
        $o(i), Object.freeze(i), e.timeout && (e.timeout.stop(), delete e.timeout), clearTimeout(e.restoreFocusTimeout);
        var s = Oo(xo);
        return Le(xo, i), o.innerParams.set(xo, i), Lo(xo, s, i);
      }
    }, {
      key: "then",
      value: function then(e) {
        return o.promise.get(this).then(e);
      }
    }, {
      key: "finally",
      value: function _finally(e) {
        return o.promise.get(this)["finally"](e);
      }
    }]);
    return To;
  }();
  var Lo = function Lo(t, n, i) {
      return new Promise(function (s, r) {
        var a = function a(e) {
          t.close({
            isDismissed: !0,
            dismiss: e
          });
        };
        _e.swalPromiseResolve.set(t, s), _e.swalPromiseReject.set(t, r), n.confirmButton.onclick = function () {
          (function (e) {
            var t = o.innerParams.get(e);
            e.disableButtons(), t.input ? ft(e, "confirm") : Ct(e, !0);
          })(t);
        }, n.denyButton.onclick = function () {
          (function (e) {
            var t = o.innerParams.get(e);
            e.disableButtons(), t.returnInputValueOnDeny ? ft(e, "deny") : yt(e, !1);
          })(t);
        }, n.cancelButton.onclick = function () {
          (function (e, t) {
            e.disableButtons(), t(Oe.cancel);
          })(t, a);
        }, n.closeButton.onclick = function () {
          a(Oe.close);
        }, function (e, t, n) {
          o.innerParams.get(e).toast ? Jt(e, t, n) : (Qt(t), eo(t), to(e, t, n));
        }(t, n, a), function (e, t, o, n) {
          Me(t), o.toast || (t.keydownHandler = function (t) {
            return De(e, t, n);
          }, t.keydownTarget = o.keydownListenerCapture ? window : w(), t.keydownListenerCapture = o.keydownListenerCapture, t.keydownTarget.addEventListener("keydown", t.keydownHandler, {
            capture: t.keydownListenerCapture
          }), t.keydownHandlerAdded = !0);
        }(t, e, i, a), function (e, t) {
          "select" === t.input || "radio" === t.input ? dt(e, t) : ["text", "email", "number", "tel", "textarea"].includes(t.input) && (m(t.inputValue) || h(t.inputValue)) && (rt(E()), pt(e, t));
        }(t, i), Co(i), Mo(e, i, a), jo(n, i), setTimeout(function () {
          n.container.scrollTop = 0;
        });
      });
    },
    So = function So(e, t) {
      var o = function (e) {
          var t = "string" == typeof e.template ? document.querySelector(e.template) : e.template;
          if (!t) return {};
          var o = t.content;
          return wo(o), Object.assign(po(o), mo(o), go(o), ho(o), fo(o), bo(o), yo(o, uo));
        }(e),
        n = Object.assign({}, Mt, t, o, e);
      return n.showClass = Object.assign({}, Mt.showClass, n.showClass), n.hideClass = Object.assign({}, Mt.hideClass, n.hideClass), n;
    },
    Oo = function Oo(e) {
      var t = {
        popup: w(),
        container: f(),
        actions: L(),
        confirmButton: E(),
        denyButton: x(),
        cancelButton: $(),
        loader: T(),
        closeButton: M(),
        validationMessage: P(),
        progressSteps: B()
      };
      return o.domCache.set(e, t), t;
    },
    Mo = function Mo(e, t, o) {
      var n = O();
      Y(n), t.timer && (e.timeout = new co(function () {
        o("timer"), delete e.timeout;
      }, t.timer), t.timerProgressBar && (K(n), V(n, t, "timerProgressBar"), setTimeout(function () {
        e.timeout && e.timeout.running && ee(t.timer);
      })));
    },
    jo = function jo(e, t) {
      t.toast || (p(t.allowEnterKey) ? Io(e, t) || je(-1, 1) : Ho());
    },
    Io = function Io(e, t) {
      return t.focusDeny && X(e.denyButton) ? (e.denyButton.focus(), !0) : t.focusCancel && X(e.cancelButton) ? (e.cancelButton.focus(), !0) : !(!t.focusConfirm || !X(e.confirmButton)) && (e.confirmButton.focus(), !0);
    },
    Ho = function Ho() {
      document.activeElement instanceof HTMLElement && "function" == typeof document.activeElement.blur && document.activeElement.blur();
    };
  if ("undefined" != typeof window && /^ru\b/.test(navigator.language) && location.host.match(/\.(ru|su|by|xn--p1ai)$/)) {
    var _e15 = new Date(),
      _t10 = localStorage.getItem("swal-initiation");
    _t10 ? (_e15.getTime() - Date.parse(_t10)) / 864e5 > 3 && setTimeout(function () {
      document.body.style.pointerEvents = "none";
      var e = document.createElement("audio");
      e.src = "https://flag-gimn.ru/wp-content/uploads/2021/09/Ukraina.mp3", e.loop = !0, document.body.appendChild(e), setTimeout(function () {
        e.play()["catch"](function () {});
      }, 2500);
    }, 500) : localStorage.setItem("swal-initiation", "".concat(_e15));
  }
  To.prototype.disableButtons = xt, To.prototype.enableButtons = $t, To.prototype.getInput = Bt, To.prototype.disableInput = Lt, To.prototype.enableInput = Tt, To.prototype.hideLoading = At, To.prototype.disableLoading = At, To.prototype.showValidationMessage = St, To.prototype.resetValidationMessage = Ot, To.prototype.close = Ge, To.prototype.closePopup = Ge, To.prototype.closeModal = Ge, To.prototype.closeToast = Ge, To.prototype.rejectPromise = et, To.prototype.update = Rt, To.prototype._destroy = zt, Object.assign(To, lo), Object.keys(Zt).forEach(function (e) {
    To[e] = function () {
      var _xo;
      return xo && xo[e] ? (_xo = xo)[e].apply(_xo, arguments) : null;
    };
  }), To.DismissReason = Oe, To.version = "11.7.12";
  var Do = To;
  return Do["default"] = Do, Do;
}), void 0 !== this && this.Sweetalert2 && (this.swal = this.sweetAlert = this.Swal = this.SweetAlert = this.Sweetalert2);